import { Injectable } from '@angular/core';
import { BassScaResetPasswordApiService } from './reset-password-api.service';
import { map } from 'rxjs/operators';

import {UserInfo} from '../../../../common-items/models/user-info.model';

@Injectable({
  providedIn: 'root'
})
export class BassScaResetPasswordService {
  userInfo: UserInfo = null;
  userName:string = '';
  otpReference: string = '';

  constructor(private resetPwdService: BassScaResetPasswordApiService) { }

  verifyToken() {
    return this.resetPwdService.verifyToken().pipe(
      map((res) => {
        return res;
      })
    );
  }

  createOTP(data :any) {
    return this.resetPwdService.createOTP(data).pipe(
      map(res => {
        return res;
      })
    );
  }

  verifyOtp(data: any) {
    return this.resetPwdService.verifyOtp(data).pipe(
      map(res => {
        return res;
      })
    );
  }

  resetPassword(data: any) {
    return this.resetPwdService.resetPassword(data).pipe(
      map(res => {
        return res;
      })
    );
  }
}
